import { Directive, ElementRef, inject } from '@angular/core';

@Directive({ selector: '[appScrollToBottom]' })
export class ScrollToBottomDirective {
  private el = inject(ElementRef);

  public scrollToBottom(): void {
    const element = this.el.nativeElement;
    element.scrollTop = element.scrollHeight;
  }
}
